import React from 'react';
import JsonView from '@/components/JsonView';

import { IRepositoryFile } from '@/types';

const tryParseJSONObject = (jsonString: string) => {
  try {
    var o = JSON.parse(JSON.stringify(jsonString));
    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) {}

  return false;
};

function getMaxArraySize(obj: object | Array<any>, maxCount: number = 0): number {
  Object.values(obj).forEach((v) => {
    maxCount = Array.isArray(v) && v.length > maxCount ? v.length : maxCount;
    const isObject = !!v && typeof v === 'object';
    return isObject ? getMaxArraySize(v, maxCount) : maxCount;
  });
  return maxCount;
}

const groupArraySize = (maxArraySize: number) => {
  if (maxArraySize < 100) {
    return 10;
  }
  if (maxArraySize < 1000) {
    return 100;
  }
  if (maxArraySize < 10000) {
    return 500;
  }
  if (maxArraySize < 50000) {
    return 1000;
  }
  return 5000;
};

const collapseDepth = (maxArraySize: number) => {
  if (maxArraySize < 10) {
    return 4;
  }
  if (maxArraySize < 100) {
    return 3;
  }
  return 2;
};

const TextFileView: React.FC<{ file: IRepositoryFile }> = ({ file }) => {
  const parsedJSON = tryParseJSONObject(file.data);
  const maxArraySize = getMaxArraySize(parsedJSON);

  const groupArraysAfterLength = groupArraySize(maxArraySize);

  return parsedJSON ? (
    <>
      {/* <div>Array Count: {maxArraySize}</div> */}
      <JsonView
        json={parsedJSON}
        groupArraysAfterLength={groupArraysAfterLength}
        collapseDepth={collapseDepth(maxArraySize)}
      />
    </>
  ) : (
    <div>Not a valid JSON object</div>
  );
  // return <Styled.TextFileView>{file.data}</Styled.TextFileView>;
};

export default TextFileView;
